import React, { useEffect, useRef, useState } from 'react';
import { Box, Paper, CardActions,Button, Typography, Chip, CircularProgress, Card, CardContent, Avatar } from '@mui/material';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import { useSelector } from 'react-redux';
import CoinSlide from './CoinSlide';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import OrderBook from '../Trader/OrderBook';

const CoinChart = () => {
    const appMode = useSelector((state) => state.mode.mode);
    const coinRates = useSelector((state) => state.coins.coinRates);
    const stocks = useSelector((state) => state.coins.stock);
    const currentPair = useSelector((state) => state.currentPair.currentPair);
    const pairType = useSelector((state) => state.currentPair.pairType);

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

    const [coinDetails, setCoinDetails ] = useState(null);

    const calculate24hrChange = (coin) => {
      let pair = {};
      if (pairType === 'stocks') {
        stocks.forEach(stock => {
          if (stock.short_name === coin) {
            pair = stock;
          }
        });
      }else{
        coinRates.forEach(coinRater => {
          if (coinRater.symbol === coin) {
            pair = coinRater;
          }
        });
      }
     
    return pair;
    }

    useEffect(() => {
      setCoinDetails(calculate24hrChange(currentPair))    
      }, [AdvancedRealTimeChart]);
  return (
    <>
    {coinDetails !== null &&
    
    <Paper 
      sx={{ 
        bgcolor: '#1a1a1a',
        p: 0,
        borderRadius: 0,
        height: 'fit-content',
        position: 'relative'
      }}
    >
      
     {/* <Box  sx={{ fontWeight: 'bold', padding: '5px', fontSize: 20, textTransform: 'uppercase', textAlign: 'center'  }}>
          <Chip icon={<SwapHorizIcon/>} label={`${currentPair}/USDT`} variant="outlined" />
      </Box> */}
      <Card px={0} elevation={0}   sx={{borderRadius: '0px', marginX: 0, height: 'fit-content', marginBottom: '-90px', width: '100%'}}>
      <CoinSlide/>
                
                        <CardContent  justifyContent="center" sx={{padding: 0, marginTop: '5px', marginX: 0, marginBottom: '0px'}}>
                        <AdvancedRealTimeChart
                                symbol= { pairType === 'stocks' ? `${coinDetails.exch}:${coinDetails.short_name}` : `BINANCE:${currentPair}USDT`}
                                interval= "D"
                                timezone= "Etc/UTC"
                                theme= {appMode}
                                locale= "en"
                                style='1'
                                hide_top_toolbar= {false}
                                enable_publishing= {false}
                                save_image={false}
                                backgroundColor={appMode === 'dark' ? '#1e1e1e' : '#ffffff'}
                                hide_side_toolbar={true}
                                allow_symbol_change={false}
                                container_id= "898980"
                                isTransparent = {true} 
                                popup_height='650'
                                popup_width='1000'
                                range='YTD'
                                
                                height={450}
                                width="100%"
                              >
                               </AdvancedRealTimeChart>
                          {appMode === 'dark'? 
                          <Box sx={{height: '20px', backgroundColor: '#1e1e1e', transform: 'translate(0px, -25px)', position: 'relative'}}>
                          
                          </Box>
                          :
                          <Box sx={{height: '20px', backgroundColor: 'white', transform: 'translate(0px, -25px)', position: 'relative'}}>
                          
                          </Box>
                          }
                          <Avatar sx={{display: 'absolute', zIndex: 10, transform: 'translate(10px, -170px)'}} alt="Payment icon" src="https://res.cloudinary.com/dnjauzgbv/image/upload/v1741162934/trustedgeappicon_j9am1e.png" />
                          
                          </CardContent>
                          

                    </Card>
                    {coinDetails !== null && 
                    <Card px={2}  sx={{borderRadius: '9px'}}>

                        <CardContent sx={{display: 'flex', justifyContent: 'space-between'}}>
                          
                           <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>                            
                                <Typography variant="h6" gutterBottom sx={{fontSize: {md: '24px', xs: '18px'} , color: `${parseFloat(coinDetails?.changePercent24Hr || coinDetails?.change_price) >= 0 ? '#198c41': '#f31348'}`}}>
                                  {(parseFloat(coinDetails.priceUsd).toFixed(6))}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '18px', xs: '14px'}}} >
                                  {formatPrice(parseFloat(coinDetails.priceUsd).toFixed(6))}
                                </Typography>
                              </Box>
                            </Box>  
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>
                                <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                  24h Change ({currentPair})
                                </Typography>
                                <Typography sx={{fontSize: {md: '9px', xs: '8px'}, color: `${parseFloat(calculate24hrChange(currentPair)?.changePercent24Hr || calculate24hrChange(currentPair)?.change_price) >= 0 ? '#198c41': '#f31348'}`}} variant="subtitle2" gutterBottom>
                                {parseFloat(coinDetails?.changePercent24Hr || coinDetails?.change_price).toFixed(6)}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                  24h Change (USDT)
                                </Typography>
                                <Typography sx={{fontSize: {md: '9px', xs: '8px'}, color: `${parseFloat(calculate24hrChange(currentPair)?.changePercent24Hr || calculate24hrChange(currentPair)?.change_price) >= 0 ? '#198c41': '#f31348'}`}} variant="subtitle2" gutterBottom>
                                {/* {parseFloat(coinDetails.changePercent24Hr).toFixed(6)} */}
                                {parseFloat(calculate24hrChange(currentPair)?.changePercent24Hr || calculate24hrChange(currentPair)?.change_price).toFixed(6)}
                                </Typography>
                              </Box>
                            </Box> 
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>
                              <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                24h Volume ({currentPair})
                              </Typography>
                              <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'}}}>
                              {parseFloat(coinDetails?.volumeUsd24Hr).toFixed(4)}
                              </Typography>
                              </Box>

                              <Box>
                              <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                24h Volume (USDT)
                              </Typography>
                              <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'}}}>
                              {parseFloat(calculate24hrChange('USDT').volumeUsd24Hr).toFixed(4)}
                              </Typography>
                              </Box>
                            </Box>   
                                                     
                        </CardContent>
                    </Card>
                  }
                {/* <Box sx={{display: 'flex', padding: '3px', transform: 'translate(0px, -20px)', justifyContent: 'flex-end', bgcolor: 'inherit'}}>
                <Box>
                  <Button  color='success' variant="contained" sx={{width: '100px' }}>
                    Buy
                  </Button>
                </Box>
                <Box sx={{marginLeft: '10px'}}>
                  <Button color='error' variant="contained" sx={{ width: '100px'}}>
                    Sell
                  </Button>
                </Box>                
              </Box>  */}
              {coinDetails !== null &&
              
              <OrderBook price={parseFloat(coinDetails.priceUsd)}/>
              }
                    
    </Paper>
      }
    </>
  );
};

export default CoinChart;
